import { object, string } from "yup";

export interface InternalTrackingSubcodeForm {
  subcode?: string;
}

export const internalTrackingSubcodeValidator = object({
  subcode: string()
    .optional()
    .trim()
    .transform((value) => value || "")
    .max(50, "Subcode must be at most 50 characters long"),
});
